import type { AuthContextType, TermsAcceptanceStatus } from '@context/auth.context';
import { actionRequest } from '@services/action-request';
import type { ActionFunction } from 'react-router-dom';

export enum ACTIONS {
  AcceptTerms = 'accept-terms',
}

export const action = (auth: AuthContextType) =>
  (async ({ request }) => {
    const { intent } = await request.json();

    switch (intent) {
      case ACTIONS.AcceptTerms:
        return await actionRequest<TermsAcceptanceStatus>(auth, request, 'auth/terms/accept');
      default:
        throw new Error(`Undefined intent '${intent}' for the action`);
    }
  }) satisfies ActionFunction;
